<template>
  <div>
    <div class="container page-top">
      <div v-if="isLoading" style="padding-top: 100px;" class="container has-text-centered opaque">
        <i class="fa fa-refresh fa-spin fa-4x"></i>
        <p>Loading...</p>
      </div>
      <div v-if="!isLoading" class="columns">
        <div class="column is-three-quarters">
          <span class="title is-5">Manage Associations</span>
          <router-link to="/associations/new" class="button is-link mobile-button">New</router-link>
        </div>
        <div class="column is-one-quarter hide-mobile">
          <div class="field list-buttons">
            <div class="control">
              <router-link to="/associations/new" class="button is-link">Create Association</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!isLoading" class="container">
      <hr>
      <section>
        <div class="columns">
          <div class="column is-three-quarters-desktop">
            <table class="table" style="width: 100%">
              <tbody>
                <tr v-for="(assoc, index) in associations" :key="assoc.key">
                  <td>
                    <router-link class="has-text-info" :to="'/associations/' + assoc.key">{{assoc.Name}}</router-link>
                  </td>
                  <td>
                    <div class="is-pulled-right" v-html="getStatus(assoc.Status)"></div>
                  </td>
                  <td style="width: 30px;">
                    <div class="is-pulled-right">
                      <div class="dropdown" :ref="'associationRow' + index">
                        <div class="dropdown-trigger">
                          <div class="icon is-small fa-button" v-on-clickaway="away" @click.stop="toggleActive('associationRow' + index)">
                            <i class="fa fa-ellipsis-v"></i>
                          </div>
                        </div>
                        <div class="dropdown-menu" id="dropdown-menu3" role="menu">
                          <div class="dropdown-content">
                            <a @click="openCopyModal(index)" class="dropdown-item">
                              Cppy Association
                            </a>
                            <a @click="openDeleteModal(index)" class="dropdown-item">
                              Delete Association
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </div>
    <div class="modal" :class="{'is-active': showDeleteModal}" v-if="showDeleteModal">
      <div class="modal-background"></div>
      <div class="modal-content">
        <div class="modal-close" @click="showDeleteModal = false"></div>
        <div class="box">
          <div class="content" style="margin-bottom: 50px;">
            <h5>Enter DELETE below to permanently delete {{associations[deleteIndex].Name}}
            </h5>
          </div>
          <div class="field" style="margin: -20px 0px 30px 0px;">
            <div class="control">
              <input class="input" type="text" v-model="deleteText" @input="checkDeleteText(deleteText)" placeholder="Enter DELETE">
            </div>
          </div>
          <button class="button is-success" @click="deleteAssociation(deleteIndex)" :disabled="disableDeleteContinue">Continue</button>
          <button @click="showDeleteModal = false" class="button">Cancel</button>
        </div>
      </div>
    </div>
    <div class="modal" :class="{'is-active': showCopyModal}" v-if="showCopyModal">
      <div class="modal-background"></div>
      <div class="modal-content">
        <div class="modal-close" @click="showCopyModal = false"></div>
        <section class="modal-card-body">
          <div class="content">
            <div class="field">
              <label class="label">New Association Name</label>
              <div class="control">
                <input class="input" type="text" v-model="copyData.newAssociationName" placeholder="New Association Name">
              </div>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot">
          <a class="button is-success" @click="copyAssociation(copyIndex, copyData.newAssociationName)">Copy</a>
          <a @click="showCopyModal = false" class="button">Cancel</a>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
  import tenant from '@/tenant'
  import { mixin as clickaway } from 'vue-clickaway'

  export default {
    name: 'AssociationsList',
    mixins: [clickaway],
    data: function () {
      return {
        isLoading: true,
        showDeleteModal: false,
        showCopyModal: false,
        copyIndex: null,
        copyData: {
          newAssociationName: ''
        },
        deleteIndex: null,
        deleteText: '',
        disableDeleteContinue: true,
        openDropdownRef: {},
        associations: []
      }
    },
    methods: {
      initialize() {
        window.document.title = 'Associations'
        this.isLoading = true
        tenant.ref('associations').once('value').then((snapshot) => {
          this.associations = tenant.getArray(snapshot.val())
          this.isLoading = false
        })
      },
      toggleActive(ref) {
        if (this.openDropdownRef.classList) {
          this.away()
          return
        }
        if (this.$refs[ref]) {
          this.openDropdownRef = this.$refs[ref][0]
          this.openDropdownRef.classList.add('is-active')
        }
      },
      openCopyModal(index) {
        this.copyIndex = index
        this.copyData.newAssociationName = ''
        this.showCopyModal = true
      },
      copyAssociation(index, newAssociationName) {
        if (newAssociationName) {
          let newAssoc = this.associations[index]
          newAssoc.Name = newAssociationName
          newAssoc.Status = 'draft'
          newAssoc.PinNumber = null
          let response = tenant.ref('associations').push(newAssoc)
          // this.setReferenceData(response.key, newAssoc)
          this.$router.push('/associations/' + response.key)
        }
      },
      openDeleteModal(index) {
        this.deleteIndex = index
        this.showDeleteModal = true
      },
      checkDeleteText(text) {
        if (text === 'DELETE') {
          this.disableDeleteContinue = false
        } else {
          this.disableDeleteContinue = true
        }
      },
      deleteAssociation(index) {
        let key = this.associations[index].key
        tenant.ref('associations/' + key).remove().then(() => {
          tenant.firebaseDb.ref('lists/agencies/' + tenant.name + '/associations/' + key).remove()
          tenant.ref('pins/' + key).remove()
          this.deleteIndex = index
          this.showDeleteModal = false
          this.deleteText = ''
          this.disableDeleteContinue = true
          this.initialize()
        })
      },
      setReferenceData(key, association) {
        if (association.Status !== 'draft') {
          tenant.firebaseDb.ref('lists/agencies/' + tenant.name + '/associations/' + key).set(association.Name)
        }

        if (association.Status === 'draft') {
          tenant.firebaseDb.ref('lists/agencies/' + tenant.name + '/associations/' + key).remove()
        }

        tenant.ref('pins/' + key).set(association.PinNumber)
      },
      away() {
        if (this.openDropdownRef.classList) {
          this.openDropdownRef.classList.remove('is-active')
          this.openDropdownRef = {}
        }
      },
      getStatus(status) {
        if (status === 'draft') {
          return '<span class="tag is-light">Draft</span>'
        }
        if (status === 'active') {
          return '<span class="tag is-info">Active</span>'
        }
        return null
      }
    },
    created: function () {
      tenant.initialize().then(() => {
        this.initialize(this.$route)
      })
    }
  }

</script>

<style scoped>
  .request-title {
    margin-bottom: 20px;
    font-size: 24px;
  }

  .fa-button {
    /* margin: 8px 10px 0px 0px; */
    vertical-align: middle;
    font-size: 20px;
    cursor: pointer;
    opacity: 0.8;
  }
</style>


// WEBPACK FOOTER //
// src/components/associations/AssociationsList.vue?96219ab0